// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_RE2","cls2":"ReferenceReportPage-cls2_C-u ReferenceReportPage-cls1_RE2"};